import React, {
  CSSProperties,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import { ThemeContext } from "../../store/ThemeProvider";
import AllForColumn2 from "../../components/GalleryList/AllForColumn2";
import { navigatorTo, getGalleryURL } from "../../utils/util";
import { style } from "../../utils/image";
import { IComponentLink } from "../../component.d";
import "../../components/Followee/Person.scss";
import MayBeOneImg, { getFaceUrl } from "../../components/Me/MayBeOneImg";
import SimpleBigPic from "../../components/BigPic/SimpleBigPic";
import { OneGalleryWithTitle } from "../../components/MyPhotos/Main";
import useSimpleBigPic from "../../components/BigPic/useSimpleBigPic";
import intl from "react-intl-universal";
import classNames from "classnames";
import OneFollowee from "../../components/Followee/OneFollowee";
import { alpha } from "../../utils/color";
import "../../components/GalleryList/gallery-list.scss";
import wxUtil from '../../utils/wx';
import {IPerson} from '../../global.d';

const PersonStatus = (props: IPerson) => {
  let { id, name, status, mainColor } = props;
  // console.log(props);
  if (status === "unfollow") {
    return (
      <>
        {intl.get("Know him/her?")}
        {Number(window.configDetail.active_on) ? (
          <span style={{ color: mainColor }}>{intl.get("Add to friends")}</span>
        ) : null}
      </>
    );
  }
  if (status === "follow") {
    return <>{name}</>;
  }
  if (status === "self") {
    return <>{intl.get("Myself")}</>;
  }

  return <div />;
};

interface IPersonDetail {
  person: IPerson;
  personAlbum: any;
  pageType?: string;
  useConfigShare?: boolean;
}

const theZIndex = 101;
const Detail = function (props: IPersonDetail) {
  const { backgroundColor, componentColor, mainColor, h1Color, h2Color } =
    useContext(ThemeContext);
  const { person, personAlbum, useConfigShare } = props;
  const { gallery } = window;
  let { data, total } = personAlbum;

  const { list, bigIndex, setBigIndex, columnsClick, loadBigPic, loadFinish } =
    useSimpleBigPic(data);

  const loc = intl.getInitOptions().currentLocale;
  const cls = classNames("icon", { en: loc !== "zh-CN" });

  let keys = Object.keys(data || {});
  keys.sort((a: string, b: string) => {
    return Number(a) > Number(b) ? -1 : 1;
  });
  keys.sort((a: string, b: string) => {
    return String(a) == String(window.gallery.id) ? -1 : 1;
  });

  const countPersonAlbum = useMemo(() => {
    let result = 0;
    if (personAlbum) {
      let { data } = personAlbum;
      let keys = Object.keys(data);
      keys.forEach((it: string) => {
        let item = data[it];
        if (item && item.images && item.images.length) {
          result += item.images.length;
        }
      });
    }

    return result;
  }, [personAlbum]);

  useEffect(() => {
    if (useConfigShare && person && person.id) {
      let oldLink = window.location.href;
      wxUtil.configPersonShare(person.id);

      return () => {
        window.history.replaceState("person", window.document.title, oldLink);
        wxUtil.configShare({});
      };
    }
  }, [useConfigShare && person && person.id]);

  // 不带这个判断可能会导致SimpleBigPic无法展示
  if (!data) {
    return null;
  }

  return (
    <div
      className="followee-person my-photos-main"
      style={{ backgroundColor: alpha(componentColor, 1), color: h1Color }}
    >
      <div className="real-list">
        <div className="avatar">
          <img src={person.faceurl} />
        </div>
        <div className="info">
          <div className="names">{person.name}</div>
          <div style={{ display: "flex", flexShrink: 0 }}>
            {useConfigShare && person && person.id ? (
              <a
                className="share"
                onClick={() => {
                  let event = new Event("show-person-share");
                  event.data = person.id;

                  window.dispatchEvent(event);
                }}
              >
                分享
              </a>
            ) : null}
            <div className="total">
              照片数<span>{countPersonAlbum || 0}</span>张
            </div>
          </div>
          {person.name ? (
            <p className="tip">（昵称自由备注，仅供参考）</p>
          ) : null}
        </div>
      </div>
      {keys.map((key: string) => {
        let it = data[key];
        return (
          <OneGalleryWithTitle
            key={it.isold ? key : it.link}
            id={it.isold ? it.id || key : it.link}
            gallery={it}
            list={it.images}
            title={it.name}
            style={{ backgroundColor: componentColor }}
            lazy={false}
            imgClick={columnsClick}
          />
        );
      })}
      <SimpleBigPic
        pageType={props.pageType || "Person"}
        index={bigIndex}
        list={list}
        setIndex={setBigIndex}
        style={{ zIndex: theZIndex }}
        loadBigPic={loadBigPic}
        loadFinish={loadFinish}
      />
    </div>
  );
};

export default Detail;
